import { protocolErrorAbi } from "./errors.js";
/** Shared Ownable2Step interface for Factory, Marketplace and new protocol beacons. */
export const ownershipEventAbi = [
    {
        type: "event",
        name: "OwnershipTransferStarted",
        inputs: [
            { name: "previousOwner", type: "address", indexed: true },
            { name: "newOwner", type: "address", indexed: true },
        ],
    },
    {
        type: "event",
        name: "OwnershipTransferred",
        inputs: [
            { name: "previousOwner", type: "address", indexed: true },
            { name: "newOwner", type: "address", indexed: true },
        ],
    },
];
export const ownershipAbi = [
    ...protocolErrorAbi,
    ...ownershipEventAbi,
    {
        type: "function",
        name: "owner",
        stateMutability: "view",
        inputs: [],
        outputs: [{ name: "", type: "address" }],
    },
    {
        type: "function",
        name: "pendingOwner",
        stateMutability: "view",
        inputs: [],
        outputs: [{ name: "", type: "address" }],
    },
    {
        type: "function",
        name: "transferOwnership",
        stateMutability: "nonpayable",
        inputs: [{ name: "newOwner", type: "address" }],
        outputs: [],
    },
    {
        type: "function",
        name: "acceptOwnership",
        stateMutability: "nonpayable",
        inputs: [],
        outputs: [],
    },
];
//# sourceMappingURL=ownership.js.map